import { InputNumber, Modal, Select, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TOQtyModalWrapper } from "./TOQtyModal.style";
import { MdOutlineErrorOutline } from "react-icons/md";
import { getReasonsListThunk } from "../../../../redux/PickerTO/Action";
import RackSearch from "../../TOBinPicker/TOBPMain/RackSearch/RackSearch";

const { Option } = Select;

export class TOQtyModal extends Component {
  state = {
    selectedQty: null,
    selectedReason: null,
    reasonList: [],
    selectedRack: null,
  };

  componentDidMount = () => {
    //this commented code is just for reference ( remove in future )
    // this.props
    //   .getReasonsListThunk({
    //     access_token: this.props.access_token,
    //     reasonType: this.props.isRacker
    //       ? "BIN_TO_BIN_RACKER"
    //       : "BIN_TO_BIN_PICKER",
    //   })
    //   .then((res) => {
    //     this.setState({ selectedQty: this.props.data?.availableQty });
    //     if (this.props.reasonsListFailure) {
    //       message.error(this.props.reasonsListFailure);
    //       this.setState({
    //         selectedReason: null,
    //         reasonList: [],
    //       });
    //     } else {
    //       this.setState({
    //         reasonList: this.props.reasonsListSuccess,
    //       });
    //     }
    //   });
    // this.setState({ selectedQty: this.props.data?.availableQty });
  };

  render() {
    let { close, data, isRacker, confirm, reasonMaster } = this.props;
    let { selectedQty, selectedReason, reasonList, selectedRack } = this.state;

    return (
      <>
        <Modal
          title={""}
          open
          centered
          onOk={() => confirm(selectedQty, selectedReason, selectedRack?.value)}
          okButtonProps={{
            disabled:
              !selectedQty ||
              (selectedQty != data?.availableQty && !selectedReason) ||
              (isRacker && !selectedRack),
          }}
          onCancel={() => close()}
        >
          <TOQtyModalWrapper>
            <p className="title">{data?.productName}</p>
            <div className="batchMapping">
              <p className="subtitle">{data?.productCode} </p>
              <p className="batch">
                Batch# <span>{data?.batchNumber}</span>{" "}
              </p>
            </div>

            <div>
              <label htmlFor="">Select QTY</label>
              <InputNumber
                style={{
                  width: "100%",
                }}
                value={selectedQty}
                placeholder="Select Quantity"
                min={0}
                max={isRacker ? data?.availableQty : 99999999999999}
                onChange={(e) => {
                  this.setState({ selectedQty: e });
                }}
              />
            </div>

            {selectedQty && selectedQty != data?.availableQty ? (
              <>
                <p className="warning">
                  <MdOutlineErrorOutline />
                  {`${
                    selectedQty < data?.availableQty ? "Partial" : "Excess"
                  } Picking !`}
                </p>

                <div>
                  <label htmlFor="">Select reason</label>
                  <Select
                    placeholder="Select reason"
                    style={{ width: "100%" }}
                    onChange={(value) =>
                      this.setState({ selectedReason: value })
                    }
                    value={selectedReason}
                  >
                    {reasonMaster[
                      isRacker
                        ? "rackerReasons"
                        : `${
                            selectedQty < data["availableQty"]
                              ? "lessQuantityReasons"
                              : "moreQtyReasons"
                          }`
                    ]?.map(
                      (k, p) =>
                        k.active && (
                          <Option value={k.reasonId} key={p}>
                            {k.value}
                          </Option>
                        )
                    )}
                  </Select>
                </div>
              </>
            ) : null}

            {isRacker ? (
              <div className="rackSearch">
                <label htmlFor="">
                  Selected Rack :{" "}
                  <span>{this.state.selectedRack?.value ?? "-"}</span>
                </label>
                <RackSearch
                  updateSelectedBin={(e) => this.setState({ selectedRack: e })}
                  redirect={"to-bin-picker-scan"}
                  onScanHandler={(e) => {
                    let data = {
                      value: e,
                      label: e,
                    };
                    this.setState({ selectedRack: data });
                  }}
                />
              </div>
            ) : null}
          </TOQtyModalWrapper>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  reasonsListSuccess: state.pickerTOReducer.reasonsListSuccess,
  reasonsListFailure: state.pickerTOReducer.reasonsListFailure,
});

const mapDispatchToProps = { getReasonsListThunk };

export default connect(mapStateToProps, mapDispatchToProps)(TOQtyModal);
